import React from 'react';
import LeftArrow from './left-arrow.svg';
import { Container, Header, Step, Title, TitleLink } from './StoryProgress.styled';

interface Props {
  title: string;
  isTitleOnly?: boolean;
  showArrow?: boolean;
  useHref?: boolean;

  currentStep?: number;
  totalSteps?: number;
  isDone?: boolean;
}

export const StoryProgress: React.FC<Props> = ({
  title,
  isTitleOnly,
  showArrow = true,
  useHref = true,
  currentStep = 0,
  totalSteps = 0,
  isDone = false,
}) => {

  if (isTitleOnly) {
    return (
      <Container>
        <Header>
          <Title>{title}</Title>
        </Header>
      </Container>
    );
  }

  const stepDisplay = `${currentStep} / ${totalSteps}`;
  const currentProgress = currentStep ? (100 / totalSteps) * currentStep : 0;

  return (
    <Container>
      <Header>
        <TitleLink to={'#'}>
          {showArrow && <LeftArrow />}
          <Title style={{ marginLeft: showArrow ? '0' : '16px' }}>{title}</Title>
        </TitleLink>
        <Step>{isDone ? 'Done' : stepDisplay}</Step>
      </Header>
      <div style={{ flex: 1 }}></div>
      {currentProgress !== 0 && <progress max='100' value={currentProgress}></progress>}
    </Container>
  );
};
